'use strict';

(function (angular) {

    angular.module('zp.map').service('mapService', mapService);

    /**@ngInject */
    function mapService($q, $rootScope, $window, mapConfig) {

        var service = this;

        service.navigate = navigate;
        service.showLocation = showLocation;

        //////////////////////////////////

        function navigate(start, end) {
            return $q.when(function () {
                if ($rootScope.webEnvironment) {
                    var url;
                    if (start && end) {
                        url = mapConfig.externalMapUrl + '?saddr=' + start.address + '&daddr=' + end.address;
                    } else if (!start && end) {
                        url = mapConfig.externalMapUrl + '?daddr=' + end.address;
                    }
                    $window.open(url);
                    return true;
                } else if (!!launchnavigator) {
                    tryOpenInDeviceApp([end.lat, end.lng], {
                        start: start.lat + ', ' + start.lng
                    });
                    return true;
                } else {
                    return false;
                }
            }());
        }

        function showLocation(location) {
            return $q.when(function () {
                if ($rootScope.webEnvironment) {
                    var url = mapConfig.externalMapUrl + '?q=' + location.lat + ',' + location.lng;
                    $window.open(url);
                    return true;
                } else if (!!launchnavigator) {
                    tryOpenInDeviceApp([location.lat, location.lng]);
                    return true;
                } else {
                    return false;
                }
            }());
        }

        function tryOpenInDeviceApp(locArray, config) {
            launchnavigator.isAppAvailable(launchnavigator.APP.GOOGLE_MAPS, function (isAvailable) {
                var app;
                if (isAvailable) {
                    app = launchnavigator.APP.GOOGLE_MAPS;
                } else {
                    app = launchnavigator.APP.USER_SELECT;
                }
                config = config ? config : {};
                config.app = app;
                launchnavigator.navigate(locArray, config);
            });
        }
    }
})(window.angular);